export default defineNuxtRouteMiddleware(async (to, from) => {
  if (import.meta.server) {
    return
  }
  const userStore = useUserStore()
  const { getUserAsync } = userStore
  const { user, fetched } = storeToRefs(userStore)
  if (!fetched.value) {
    try {
      await getUserAsync()
    } catch {
      // Si pas connecté
      if (from.name !== 'index' && to.meta.requiresAuth) {
        return navigateTo({ name: 'index', query: { ...from.query, redirect: to.name as string, modal: 'login' } })
      }
    }
  }
  if (!user.value?.data && from.name !== 'home' && to.meta.requiresAuth) {
    return navigateTo({ name: 'index', query: { ...from.query, redirect: to.name as string, modal: 'login' } })
  }
})
